import { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import axios from "axios";
import moment from "moment";

import { BottomsheetDropdown } from "components";
import { MOBILE_NO_VALIDATION, PAN_NUMBER_REGEX } from "constants/Constants";
import * as APITypes from "../../../../../../../constants/API";
import './is-existing-customer-modal-fdp.css'
import CustomizationLoader from "components/ui/customization-loader/CustomizationLoader";

const IsExistingCustomerModalForFDP = (props) => {
    const { formRef, show, onHide, productData } = props

    const [searchType, setSearchType] = useState({ id: "customer_id", label: "Customer ID" })
    const [searchValue, setSearchValue] = useState({ value: "", errorMessage: "" })
    const [dobValue, setDobValue] = useState({ value: "", errorMessage: "", showDOB: false })
    const [IsExistingCustomer, setIsExistingCustomer] = useState({ status: false, message: "" })
    const [loading, setLoading] = useState(false)
    const optionList = [
        { id: "customer_id", label: "Customer ID" },
        { id: "mobile_number", label: "Mobile Number" },
        { id: "pan_number", label: "Pan Number" },
        { id: "policy_number", label: "Policy Number" }
    ]

    useEffect(() => {
        let searchByKey = productData?.bi_request?.search_key
        let searchByValue = productData?.bi_request?.search_value
        let laDate = productData?.bi_request?.LI_DOB
        if (searchByKey) {
            let value = optionList?.find((item) => item?.id === searchByKey)
            setSearchType(value)
            setSearchValue({ value: searchByValue, errorMessage: "" })
            if (searchByKey === "mobile_number" || searchByKey === "policy_number") {
                let formattedDate = moment(laDate, "DD MMM YYYY")?.format("YYYY-MM-DD");
                setDobValue({ value: formattedDate, errorMessage: "", showDOB: true })
            } else {
                setDobValue({ value: "", errorMessage: "", showDOB: false })
            }
        }
    }, [])

    const onSearchTypeChanges = (searchTypeValue) => {
        if (searchTypeValue.id === "mobile_number" || searchTypeValue?.id === "policy_number") {
            setDobValue({ value: "", errorMessage: "", showDOB: true })
        } else {
            setDobValue({ value: "", errorMessage: "", showDOB: false })
        }
        setSearchValue({ value: "", errorMessage: "" })
        setIsExistingCustomer({ value: false, message: '' })
    }
    const onClose = () => {
        onHide(IsExistingCustomer?.status)
    }

    const validation = (currentValue) => {
        setIsExistingCustomer({ value: false, message: '' })
        switch (searchType?.id) {

            case "mobile_number": // ! FOR MOBILE NO VALIDATION
                const mobileNoValue = currentValue?.replace(/[^0-9 ]/g, "")
                if (MOBILE_NO_VALIDATION.test(mobileNoValue || currentValue === "")) {
                    setSearchValue(prevState => ({ ...prevState, value: currentValue, errorMessage: "" }))
                } else {
                    setSearchValue(prevState => ({ ...prevState, value: currentValue, errorMessage: "Please enter a valid Mobile Number" }))
                }
                if (currentValue.length > 10) {
                    const value = currentValue.slice(0, 10)
                    setSearchValue(prevState => ({ ...prevState, value: value }))
                }
                break

            case "customer_id":
                setSearchValue(prevState => ({ ...prevState, value: currentValue }))
                break

            case "policy_number":
                setSearchValue(prevState => ({ ...prevState, value: currentValue }))
                break

            case "pan_number": // ! FOR PAN NO VALIDATION                
                if ((PAN_NUMBER_REGEX.test(currentValue)) || currentValue === "") {
                    setSearchValue(prevState => ({ ...prevState, value: currentValue, errorMessage: "" }))
                } else {
                    setSearchValue(prevState => ({ ...prevState, value: currentValue, errorMessage: "Please enter a valid Pan Number" }))
                }
                if (currentValue.length > 10) {
                    const value = currentValue.slice(0, 10)
                    setSearchValue(prevState => ({ ...prevState, value: value }))
                }
                break;

            default:
                break;
        }
    }

    const validateData = async () => {
        if (dobValue?.showDOB && !dobValue?.value) {
            setDobValue(prevState => ({ ...prevState, errorMessage: "This field is mandatory" }))
        }
        if (!searchValue?.value) {
            setSearchValue(prevState => ({ ...prevState, errorMessage: "This field is mandatory" }))
            return
        }
        if (searchValue?.value && dobValue?.showDOB && !dobValue?.value) {
            return
        }

        let requestObj = {
            "search_key": searchType?.id,
            "search_value": searchValue?.value,
            "dob": dobValue?.value ? dobValue?.value : "",
            "family_product_id": productData?.family_product_id
        }
        setLoading(true)

        const response = await axios.post(APITypes.VALIDATE_EXISTING_CUSTOMER, requestObj);
        if (response?.data) {
            setIsExistingCustomer({ status: response?.data?.isExistingCustomer ? true : false, message: response?.data?.message ? response?.data?.message : "data not found " })
        }
        setLoading(false)
    }


    return (
        <>
            <div>
                <Modal
                    size="lg"
                    className="save-session-modal fund-distribution-modal"
                    show={show}
                    centered
                    keyboard={false}
                    onHide={onClose}
                >
                    <Modal.Header closeButton className="border-0 fund-distribution-modal-padding">
                        <Modal.Title className="font-size-16 text-header-style">
                            <div className="font-weight-normal text-primary">
                                <strong>Validate Existing Customer</strong>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="is-existing-cusstomer-fdp-body border-0">
                        <div className='row mt-2'>
                            <div className='col-lg-6 col-12'>
                                <div className='row'>
                                    <div className='col-12'>
                                        <p className='pre-need-modal-label font-weight-medium'>Search By</p>
                                    </div>
                                </div>
                                <BottomsheetDropdown
                                    dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemStyle='d-flex justify-content-between align-items-center'
                                    menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    selectedLabelKey='label'
                                    bottomsheetTitle={"Select an Option"}
                                    menuList={optionList}
                                    value={searchType}
                                    // showErrorMsg={formController.$("existing_customer_type_option_list").error !== null}
                                    // errorMsg={formController.$("existing_customer_type_option_list").error}
                                    onSelect={(e) => {
                                        setSearchType(e),
                                            onSearchTypeChanges(e)

                                    }}
                                    disabled={false}
                                />
                            </div>

                            <div className='col-lg-6 col-12 '>
                                <div className='row mt-2 mt-lg-0'>
                                    <div className='col-12'>
                                        <p className='pre-need-modal-label font-weight-medium'>{searchType?.label}</p>
                                    </div>
                                </div>
                                <Form.Group className='mb-0'>
                                    <Form.Control
                                        type={searchType.id === "mobile_number" ? "number" : "text"}
                                        className='font-size-lg-12 font-size-14 font-weight-light'
                                        placeholder={`Enter ${searchType?.label}`}
                                        value={searchValue?.value}
                                        onChange={(e) => { validation(e?.target?.value) }}
                                        style={searchValue?.errorMessage ? { border: "1px solid red" } : { border: "1px solid grey" }}
                                    />
                                    {searchValue?.errorMessage ? (
                                        <p className='font-size-12 font-weight-light text-danger mb-0'>{searchValue?.errorMessage}</p>
                                    ) : null}
                                </Form.Group>
                            </div>
                            {dobValue?.showDOB &&
                                <>
                                    <div className='col-lg-6 col-12'> </div>
                                    <div className='col-lg-6 col-12 mt-1 '>
                                        <div className='row'>
                                            <div className='col-12'>
                                                <p className='pre-need-modal-label font-weight-medium'>Date Of Birth</p>
                                            </div>
                                        </div>
                                        <input
                                            type="date"
                                            id="dob"
                                            name="dob"
                                            className={`w-100 pre-need-dob ${dobValue?.errorMessage ? 'pre-need-dob-error' : ''}`}
                                            value={dobValue?.value}
                                            onChange={(e) => {
                                                const value = e?.target?.value;
                                                const date = new Date(value);
                                                const isValid = !isNaN(date?.getTime());
                                                if (value.length === 10 && isValid) {
                                                    setDobValue(prevState => ({ ...prevState, errorMessage: "", value }));
                                                } else {
                                                    setDobValue(prevState => ({ ...prevState, errorMessage: "Invalid date", value: "" }));
                                                }
                                            }}
                                            max={moment().subtract(18, 'years').format('YYYY-MM-DD')}
                                        />
                                        {dobValue?.errorMessage ? (
                                            <p className='font-size-12 font-weight-light text-danger mb-0'>{dobValue?.errorMessage}</p>
                                        ) : null}
                                    </div>
                                </>
                            }
                            {IsExistingCustomer?.message && <p className={`mt-4 mx-3 ${IsExistingCustomer?.status ? 'text-success' : 'text-danger'}`}>{IsExistingCustomer?.message}</p>}
                            {loading &&
                                <div className="d-flex justify-content-center w-100 mt-3">
                                    <CustomizationLoader />
                                </div>
                            }

                            {!IsExistingCustomer?.message &&
                                <div className="text-center w-100">
                                    <button type="button" onClick={() => validateData()} class="btn btn-secondary btn-lg modal-cta-btn py-2 py-lg-1 mt-2 mb-2 mb-lg-0 font-size-14 font-size-lg-13 font-weight-medium w-25 mt-3">Validate</button>
                                </div>
                            }
                            {IsExistingCustomer?.message &&
                                <div className="text-center w-100">
                                    <button type="button" onClick={() => onClose()} class="btn btn-secondary btn-lg modal-cta-btn py-2 py-lg-1 mt-2 mb-2 mb-lg-0 font-size-14 font-size-lg-13 font-weight-medium w-25 mt-3">Close</button>
                                </div>
                            }

                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </>
    )

}
export default IsExistingCustomerModalForFDP;